import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc DefaultPhoneNumberAutoRefill defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { DefaultPhoneNumberAutoRefillService } from 'services/defaultPhoneNumberAutoRefill';
 *
 * // create service instance and send/cancel request
 * const defaultPhoneNumberAutoRefillService = new DefaultPhoneNumberAutoRefillService();
 * const result = await defaultPhoneNumberAutoRefillService.fetchData( '<user-id>' ); // fetch data
 * defaultPhoneNumberAutoRefillService.cancel(); // cancel an active request
 */
export class DefaultPhoneNumberAutoRefillService extends HttpService {

    // fetch add phone number info
    async fetchAddForm( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            const fields = get( response, 'body.component.structure.fields', {} );
            const actions = get( response, 'body.component.structure.actions', [] );
            const values = get( response, 'body.component.data', [] );
            const addTitle = get( response, 'body.component.structure.title', [] );
            const editTitle = get( response, 'body.component.structure.editTitle', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    fields,
                    actions,
                    values,
                    addTitle,
                    editTitle
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async submitForm( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    description: get( response, 'body.component.data.description', '' )
                }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
